module.exports = __webpack_public_path__ + "img/gosbi_white.0621cf13.png";